import { CALCULATE_SOURCE_NET } from '../constants/bookkeeping/InvoiceItems';

export default (payload = {}) => {
  return {
    quantity: '1,000000',
    gross_price: null,
    net_price: null,
    source: CALCULATE_SOURCE_NET,
    payment_deadline: null,
    ...payload,
  };
}
